<div>
  <div class="generic-header-wrapper__header">
    <h2 class="generic-header-wrapper__name">{{props['name']}}</h2>
    <ng-container *ngIf="hasErrors()">
      <p class="generic-header-wrapper__error">Fields in this section contain errors</p>
    </ng-container>
  </div>
  <ng-container #fieldComponent></ng-container>
</div>

